module.exports = __webpack_public_path__ + "Current-Contractor-Blue.svg";